import {BaseFormModel} from './base-form-model';

export class TabSearchResult extends BaseFormModel<TabSearchResult> {
    id: number;
    tabNumber: string;
    name: string;
    serverName: string;
    email: string;
    subtotal: number;
    invoiced: number;
    tip: number;
    status: string;
    startTime: string;
    payments: number;
    refunds: number;
    credits: number;
    paymentStatus: string;
    deviceId: string;
    member: boolean;
    memberNumber: number;
    pickupLocationId: number;
    pickupLocationName: string;
}
